/* eslint-disable curly */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: true,
	name: 'normalPercent'
})
export class NormalPercentPipe implements PipeTransform {
	transform(value: number): any {
		if (!value) return 0;
		if (value > 100) return Math.round(value);

		try {
			if (+value === 0) return 0;
			const decimalPart = value.toString().split('.')[1];
			if (decimalPart?.length > 2) return Math.trunc(+(+value) * 100) / 100;
			return value;
		} catch (e) {
			return 0;
		}
	}
}
